import * as React from 'react';
import { cn } from '@/lib/cn';

export type InputProps = React.InputHTMLAttributes<HTMLInputElement>;

const Input = React.forwardRef<HTMLInputElement, InputProps>(
  ({ className, type, ...props }, ref) => (
    <input
      type={type}
      ref={ref}
      className={cn(
        'flex h-8 w-full rounded-md border border-input bg-background px-3 py-1 text-base text-foreground',
        'transition-[border-color,box-shadow] duration-150',
        'placeholder:text-muted-foreground',
        // ONE border plus a soft halo that hugs it.
        //
        // The previous treatment was `border-primary` + `ring-2` +
        // `ring-offset-1`, which paints a violet line, a white gap, then a
        // second violet ring - a visible DOUBLE border on every focused field.
        // Dropping the offset collapses it to a single edge with a glow behind
        // it, which is what the shape was always meant to be.
        'focus-visible:border-primary focus-visible:outline-none focus-visible:ring-[3px] focus-visible:ring-primary/20',
        'disabled:cursor-not-allowed disabled:bg-muted disabled:opacity-60',
        // Bound to the field's own aria-invalid, so a server-side
        // VALIDATION_FAILED needs no extra class threading to show red.
        'aria-[invalid=true]:border-destructive aria-[invalid=true]:ring-destructive/20',
        className,
      )}
      {...props}
    />
  ),
);
Input.displayName = 'Input';

export { Input };
